export enum CinchLoanType {
  Residential = 'res',
  Commercial = 'com',
  FixAndFlip = 'fnf',
  Construction = 'con',
  MultiFamilyCommercial = 'mfcom',
  FMSBMultifamily = 'fmsbmf',
  Sterling = 'sterling',
}
